import store from '@/store'

export function setupRouteGuards(router) {
  router.beforeEach(async (to, from, next) => {
    // Initialize auth state on first load
    if (!store.state.auth.isAuthenticated && store.state.auth.token) {
      await store.dispatch('auth/initializeAuth')
    }
    
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const isAdmin = store.getters['auth/isAdmin']
    const isSuperAdmin = store.getters['auth/isSuperAdmin']
    const hasRole = store.getters['auth/hasRole']
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
    
    // Check for role-based requirements
    const requiredRoles = to.matched.find(record => record.meta.requiresRoles)?.meta.requiresRoles
    const hasRequiredRole = requiredRoles ? requiredRoles.some(role => hasRole(role)) : true
    
    // Set page title
    if (to.meta.title) {
      document.title = `${to.meta.title} - MIL Dash™`
    }
    
    // Check authentication requirements
    if (requiresAuth && !isAuthenticated) {
      // Redirect to login if authentication required but user not authenticated.
      // Must NOT be a guarded route, or the guard rejects it again and loops forever.
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if (requiresGuest && isAuthenticated) {
      // A signed-in user on a guest page (like /login) goes to the Dashboard (T20)
      next({ name: 'Dashboard' })
    } else if (requiresAdmin && !isAdmin && !isSuperAdmin) {
      // Redirect to the profile page if admin required but user is not admin.
      // UserProfile only requires auth (no role gate), so it always resolves.
      next({ name: 'UserProfile' })
    } else if (requiredRoles && !hasRequiredRole) {
      // Redirect to the profile page if specific roles required but user doesn't have them
      next({ name: 'UserProfile' })
    } else {
      // Proceed normally
      next()
    }
  })
  
  router.afterEach(() => {
    // Hide loading indicator if any
    store.dispatch('app/setLoading', false)
  })
}